import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'targetName'})
export class TargetNamePipe implements PipeTransform {
  transform(targetName: string): string {
    return targetName.split('|').shift();
  }
}
